<template>
  <div class="content">
      <router-view/>
  </div>
</template>

<script>
// import Footer from '@/components/navigation/Footer.vue'
// import Header from '@/components/navigation/Header.vue'

export default {
    name: 'Guest',
    // components: {
    //     Footer,
    //     Header
    // }
}
</script>

<style scoped>
.main-content {
    min-height: 600px;
}
</style>
